import classnames from 'classnames';
import React      from 'react';

import { Check }  from 'react-feather';


export default function OnboardingSection({ className, children, collapsed, onClick }) {
  const classNames = classnames('onboarding-section', className, { collapsed });
  return (
    <div className={classNames} onClick={onClick}>
      <div className="section-content">
        {children}
        <CheckCircle/>
      </div>
    </div>
  );
}


function CheckCircle() {
  return (
    <div className="check-circle">
      <Check/>
    </div>
  );
}
